import React, { useEffect, useState } from 'react';
import "../Styles/Roi.css";
import Roi1 from "../Resource/Roi/costofliving.png";
import Roi2 from "../Resource/Roi/investment.png";
import Roi3 from "../Resource/Roi/modernhouse.png";
import RoiBanner from "../Resource/Roi/realimg1.png";
import RoiBanner2 from "../Resource/MapInfo/madura-img2.png";
import RoiBanner4 from "../Resource/MapInfo/shama-img1.png";
import RoiBanner3 from "../Resource/Roi/Roi_banner_2.jpg";

const roiData = [
  {
    title: "The Vision",
    bottom_title: "Signature Villas",
    description: "Prasiddh is an 19 acre eco-village near Ramanagara, just an hour from Bangalore and a minute from the upcoming STRR Highway. Designed for conscious living, it combines nature, wellness, and premium lifestyle with long-term investment value. Each villa is set amidst green landscapes with access to high-end resort amenities.",
    icon: Roi3,
    images: [RoiBanner4, RoiBanner2],
  },
  {
    title: "ROI On Resort",
    bottom_title: "Resort Living",
    description: "Resorts generate passive income through rentals, tourism, and hospitality. With seasonal demand and leisure trends rising, they offer high ROI potential, branding value, and consistent earnings across vacation and event seasons.",
    icon: Roi1,
    images: [RoiBanner2],
  },
  {
    title: "ROI On Others",
    bottom_title: "Smart Investment",
    description: "Other ventures include agro-tourism, eco-retreats, and commercial leasing. These assets cater to niche markets, enable revenue diversity, and offer low-risk income opportunities by leveraging unique land usage and lifestyle demand.",
    icon: Roi2,
    images: [RoiBanner3, RoiBanner, RoiBanner3],
  },
];

const Roi = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [animationKey, setAnimationKey] = useState(0);
  const activeData = roiData[activeIndex];
  const hasMultipleImages = activeData.images.length > 1;

  // Carousel auto-switch
  useEffect(() => {
    if (!hasMultipleImages) return;
    const imgInterval = setInterval(() => {
      setCarouselIndex((prev) =>
        prev === activeData.images.length - 1 ? 0 : prev + 1
      );
    }, 3000);
    return () => clearInterval(imgInterval);
  }, [activeIndex, activeData.images.length]);

  return (
    <div className='Roi-container'>
      <div className='Roi-sub-container-1'>
        <div 
          key={`title-${animationKey}`} 
          className='Roi-card-title slide-in-right'
        >
          {activeData.title}
        </div>
        <div 
          key={`description-${animationKey}`} 
          className='Roi-card-content slide-in-right slide-in-delayed'
        >
          {activeData.description}
        </div>

        <div className='Roi-bottom-cards-holder'>
          {roiData.map((item, index) => (
            <React.Fragment key={index}>
              <div
                className={`Roi-bottom-card animate ${activeIndex === index ? 'active-card' : ''}`}
              >
                <div className='Roi-bottom-card-image'>
                  <img src={item.icon} alt={item.bottom_title} />
                </div>
                <div className='Roi-bottom-card-title'>{item.bottom_title}</div>
              </div>
              {index < roiData.length - 1 && <div className='Roi-bottom-card-line'></div>}
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className='Roi-sub-container-2 animate'>
        <div className="carousel-wrapper" style={{ position: 'relative' }}>
          <img
            src={activeData.images[carouselIndex]}
            alt='ROI Visual'
            className='carousel-image'
          />

          {hasMultipleImages && (
            <div className="Gallery-pagination-dots-holder">
              <div
                className="Gallery-pagination-dots-holder-background-highlighter"
                style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}
              >
                {activeData.images.map((_, i) => (
                  <div
                    key={i}
                    className={i === carouselIndex ? 'pagination-dot-active' : 'pagination-dot'}
                    onClick={() => setCarouselIndex(i)}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Roi;
